import { FunctionalLocationNode, ScheduledHours, WorkOrderWithScore } from './functional-location-hierarchy-scores-propagation.utils';

export class CapacityDistributionCalculator {
  private static readonly MAX_WEEKS = 17;

  static calculateCapacityDistributions(node: FunctionalLocationNode): void {
    const nodeCapacityDistribution: { [week: number]: ScheduledHours } = {};

    CapacityDistributionCalculator.InitializeCapacityDistribution(nodeCapacityDistribution);

    this.updateCapacityDistribution(node.ReleasedWorkOrders, nodeCapacityDistribution);

    this.updateCapacityDistribution(node.NotReleasedWorkOrders, nodeCapacityDistribution);

    node.Children.forEach(child => {
      this.sumCapacityDistributions(nodeCapacityDistribution, child.CapacityDistribution);
    });

    node.CapacityDistribution = nodeCapacityDistribution;
  }

  private static InitializeCapacityDistribution(nodeCapacityDistribution: { [week: number]: ScheduledHours; }) {
    for (let week = -1; week <= this.MAX_WEEKS; week++) {
      nodeCapacityDistribution[week] = {
        CommitedHours: 0.0,
        UncommitedHours: 0.0
      };
    }
  }

  private static updateCapacityDistribution(
    workOrders: WorkOrderWithScore[],
    workOrdersCapacityDistributions: { [week: number]: ScheduledHours }
  ): void {
    workOrders.forEach(workOrder => {
      if (workOrder.CapacityDistribution) {
        for (let week = -1; week <= this.MAX_WEEKS; week++) {
          if (workOrder.CapacityDistribution[week]) {
            workOrdersCapacityDistributions[week].CommitedHours +=
              workOrder.CapacityDistribution[week].CommitedHours;
            workOrdersCapacityDistributions[week].UncommitedHours +=
              workOrder.CapacityDistribution[week].UncommitedHours;
          }
        }
      }
    });
  }

  private static sumCapacityDistributions(
    target: { [week: number]: ScheduledHours },
    source?: { [week: number]: ScheduledHours }
  ): void {
    if (!source || Object.keys(source).length === 0) return;

    for (let week = -1; week <= this.MAX_WEEKS; week++) {
      if (source[week]) {
        target[week].CommitedHours += source[week].CommitedHours;
        target[week].UncommitedHours += source[week].UncommitedHours;
      }
    }
  }
}
